import { render } from "./BarProgress3.vue?vue&type=template&id=a3bc00fa"
import script from "./BarProgress3.vue?vue&type=script&lang=js"
export * from "./BarProgress3.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/BarProgress3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a3bc00fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a3bc00fa', __exports__)) {
    api.reload('a3bc00fa', __exports__)
  }
  
  module.hot.accept("./BarProgress3.vue?vue&type=template&id=a3bc00fa", () => {
    api.rerender('a3bc00fa', render)
  })

}


export default __exports__